import { handleActions } from 'redux-actions';

import { resourceStoreTypes, resourceUpserters } from '../core';
import * as actions from './investmentIRRActions';

const investmentIRRReducer = handleActions(
  {
    [actions.getInvestmentIRR]: (state) => state.merge({ isLoading: true }),
    //  TODO: Ask QCS to fix it so we do not need to destroy old data and start fresh
    [actions.getInvestmentIRRSuccess]: (state, { payload }) =>
      resourceUpserters.upsertResources(state, payload.merge({ replaceCollection: true })),
    [actions.getInvestmentIRRFailure]: (state, { payload: error }) => resourceUpserters.completeWithError(state, error),
  },
  resourceStoreTypes.mkQcsSyncResourceStore(),
);

export const INVESTMENT_IRR_REDUCER_KEY = 'investmentIRRStore';
export default investmentIRRReducer;
